module.exports = __webpack_public_path__ + "assets/category_type-af3ae9.svg";